var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.9271,
    cy: 25.9273,
    r: 21.703,
    transform: "rotate(12.6439 25.9271 25.9273)",
    fill: "#299900",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.927,
    cy: 25.9272,
    r: 13.3018,
    transform: "rotate(12.6439 25.927 25.9272)",
    fill: "#299900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.291 28.9368C18.2371 28.9928 18.2008 29.0634 18.1866 29.1399C18.1724 29.2163 18.1809 29.2953 18.2112 29.3669C18.2414 29.4386 18.2921 29.4998 18.3568 29.5429C18.4215 29.5861 18.4974 29.6093 18.5752 29.6097L31.0244 29.6757L31.0251 29.676L31.4117 29.6787C31.485 29.6792 31.5569 29.6594 31.6196 29.6215C31.6823 29.5836 31.7333 29.5292 31.767 29.4642C31.8007 29.3991 31.8157 29.3261 31.8105 29.253C31.8053 29.18 31.7799 29.1098 31.7373 29.0502L31.5132 28.7362L31.5131 28.7344L28.7862 24.9012L27.9402 20.2737L27.9394 20.2716L27.8705 19.8921C27.8574 19.8202 27.8246 19.7533 27.7759 19.6988C27.7271 19.6443 27.6643 19.6043 27.5943 19.5833C27.5243 19.5622 27.4498 19.5608 27.3791 19.5794C27.3084 19.5979 27.2442 19.6356 27.1935 19.6882L18.291 28.9368ZM20.2056 28.0935L27.9634 24.8175L28.0206 25.1306C28.0311 25.188 28.0541 25.2425 28.0879 25.29L28.2725 25.5494L20.5147 28.8254L19.5066 28.8199L20.2049 28.0932L20.2056 28.0935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current_location.69148cfdbb8d100cc17e6a259815b116.svg";
export { ForwardRef as ReactComponent };